import { JobService } from "../../services";
import { createCRUDThunksLegacy } from "../../shared/helpers";
import { IJobRequest, IJobResponse } from "../../shared/types";

const service = new JobService();
export const jobThunks = createCRUDThunksLegacy<IJobResponse, IJobRequest>({
  service,
  resourceName: "jobs",
});
